import React from 'react';
import { useParams } from 'react-router-dom';
import ContractCreate from './ContractCreate';

const ContractEdit = () => {
  const { id } = useParams();
  // ContractCreate already handles edit mode when id is provided
  return <ContractCreate />;
};

export default ContractEdit;

